// React
import { memo, useCallback } from "react";

// Helpers
import { classNames } from "helpers";

// UI
import Tooltip from "ui/components/Tooltip/Tooltip";

import { FieldConfidenceProps } from "./types";

/** Iznad ovoga je podatak pouzdan, ispod druge granice ga treba provjeriti. */
const HIGH_CONFIDENCE = 0.9;
const MEDIUM_CONFIDENCE = 0.7;

/**
 * Omotač oko polja koje je popunjeno čitanjem računa: pokazuje koliko je podatak pouzdano pročitan
 * i javlja kad je korisnik na njemu, da se odgovarajuće mjesto istakne na prikazu računa. Fokus se
 * hvata na omotaču, pa samo polje ostaje netaknuto.
 */
const FieldConfidence: React.FC<FieldConfidenceProps> = (props) => {
  const { fieldKey, confidence, onFieldFocus, children } = props;

  const handleFocus = useCallback(() => {
    onFieldFocus?.(fieldKey);
  }, [fieldKey, onFieldFocus]);

  const handleBlur = useCallback(() => {
    onFieldFocus?.(null);
  }, [onFieldFocus]);

  const percentage = confidence != null ? Math.round(confidence * 100) : null;

  return (
    <div className="relative" onFocusCapture={handleFocus} onBlurCapture={handleBlur}>
      {children}

      {percentage != null && (
        <div className="absolute right-0 top-0">
          <Tooltip
            decorate={
              <span
                className={classNames(
                  "block w-2 h-2 rounded-full",
                  confidence! >= HIGH_CONFIDENCE
                    ? "bg-emerald-500"
                    : confidence! >= MEDIUM_CONFIDENCE
                      ? "bg-amber-500"
                      : "bg-red-500"
                )}
              />
            }
            position="bottom-right"
            size="small"
          >
            <span className="text-xs whitespace-nowrap">Pouzdanost čitanja: {percentage} %</span>
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export default memo(FieldConfidence);
